import { request } from "@src/utils/apiClient";
import SignolUtils from "@src/utils/signolUtils";

export const login = ({ username, password }) => {
  return request({
    method: "POST",
    endpoint: "/auth/login",
    body: {
      username,
      password,
    },
  });
};

export const exchangeSSO = (code) => {
  const { clientId, redirectUri } = SignolUtils.getCognitoClient();
  return request({
    method: "POST",
    endpoint: "/auth/exchange",
    body: {
      code,
      clientId,
      redirectUri,
    },
  });
};

export const refreshToken = (refreshToken) => {
  const req = {
    refreshToken: refreshToken || SignolUtils.getCurrentRefreshToken(),
  };
  if (SignolUtils.isCurrentSSOSession()) {
    const { clientId, redirectUri } = SignolUtils.getCognitoClient();
    req.clientId = clientId;
    req.redirectUri = redirectUri;
  }
  return request({
    method: "POST",
    endpoint: "/auth/refresh",
    body: { ...req },
  });
};

export const impersonateLogin = ({ customerCode, username }) => {
  return request({
    method: "POST",
    endpoint: "/identity/profile/impersonateLogin",
    body: {
      customerCode,
      username,
    },
  });
};

export const impersonateLogout = (adminIdentityId) => {
  return request({
    method: "POST",
    endpoint: "/identity/profile/impersonateLogout",
    body: {
      adminIdentityId,
    },
  });
};

export const getMeIdentity = () => {
  return request({
    method: "GET",
    endpoint: "/identity/profile/me?" + new Date().getTime(),
  });
};

export const verifyOperatorCode = (
  operatorCode,
  customerCode,
  checkAssigned = false,
) => {
  return request({
    method: "GET",
    endpoint: "/operatorDashboard/internal/verifyOperator",
    params: {
      operatorCode,
      customerCode: customerCode || undefined,
      checkAssigned,
    },
  });
};

export const verifyEmailAddressInCustomer = (
  email,
  customerCode,
  checkAssigned = false,
) => {
  return request({
    method: "GET",
    endpoint: "/operatorDashboard/internal/verifyCompanyEmail",
    params: {
      email,
      customerCode,
      checkAssigned,
    },
  });
};

export const getCustomerStatus = (customerCode) => {
  return request({
    method: "GET",
    endpoint: "/operatorDashboard/internal/customerStatus",
    params: { customerCode },
  });
};

export const signup = (data) => {
  return request({
    method: "POST",
    endpoint: "/auth/signup",
    body: { ...data },
  });
};

export function requestChangePassword(changeRequest) {
  return request({
    method: "POST",
    endpoint: "/identity/profile/changePassword",
    body: { ...changeRequest },
  });
}

export function requestForgotPassword({ username }) {
  return request({
    method: "POST",
    endpoint: "/auth/forgotPassword",
    body: { username },
  });
}

export function requestResetPassword(req) {
  return request({
    method: "POST",
    endpoint: "/auth/resetPassword",
    body: { ...req },
  });
}

export function getOperatorSecurityQuestion(username) {
  return request({
    method: "GET",
    endpoint: "/operatorDashboard/userSecurityQuestion",
    params: { username },
  });
}

export function verifyOperatorSecurityQuestion(data) {
  return request({
    method: "POST",
    endpoint: "/operatorDashboard/verifySecurityQuestion",
    body: { ...data },
  });
}

export function crewUpdateInternal(body) {
  return request({
    method: "POST",
    endpoint: "/operatorDashboard/internal/crew_update",
    body,
  });
}
